/* eslint-disable @typescript-eslint/typedef */
import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {select, Store} from '@ngrx/store';
import {AuthNgrx} from '~model/ngrx/auth-ngrx';
import {FeatureFiltroActionsTypes} from './feature-filtro.actions';
import {first, tap} from 'rxjs/operators';
import {FiltroModel} from './feature-filtro.model';
import {entityRotaSelectAll} from '~entity/entity-rota/entity-rota.selectors';
import {RotaVo} from '~model/vo/rota-vo';
import {List} from 'immutable';
import {CondicaoTypes} from '~utils/condicao-types';
import {FiltroContainer} from '~model/filtro/filtro-container';
import {Filtro} from '~model/filtro/filtros/filtro';
import {upsertEntityRotas} from '~entity/entity-rota/entity-rota.actions';
import {EntityRota} from '~entity/entity-rota/entity-rota.model';

@Injectable()
export class FeatureFiltroEffects {

  filtroRotas$ = createEffect(() => this.actions$.pipe(
    ofType(FeatureFiltroActionsTypes.SetInputFilter),
    tap((action: FiltroModel) => {
      this.store.pipe(select(entityRotaSelectAll), first()).subscribe(state => {
          const visiveis = List(state).filter(r => !r.oculto).map(r => r.id);
          const rotasFiltradas = List(FeatureFiltroEffects.pesquisaFilterConf(state, action.filtros));
          const visiveisFiltrados = rotasFiltradas.map(r => r.id);
          if (!visiveis.equals(visiveisFiltrados)) {
            const entities = state.map(r => ({...r, oculto: !visiveisFiltrados.includes(r.id)} as EntityRota));
            this.store.dispatch(upsertEntityRotas({entities}) as any);
          }
        }
      );
    })
  ), {
    dispatch: false,
  });

  constructor(
    private actions$: Actions,
    private store: Store<AuthNgrx>
  ) {
  }

  private static pesquisaFilterConf(rotas: RotaVo[], filtros: Filtro<RotaVo>[]): RotaVo[] {
    const filtrosValidos = filtros.filter((filtro) => filtro.getComparadores().length >= 1);
    const temFiltrosValidos = filtrosValidos.length >= 1;

    let resultado: RotaVo[];
    if (temFiltrosValidos) {
      // Usar o FiltroContainer original
      const filtroContainer = new FiltroContainer(rotas, CondicaoTypes.IF);
      filtroContainer.addFiltros(filtros);
      const resultadoBruto = filtroContainer.aplicar();

      // FIX: Remover duplicatas e aplicar filtro manual para garantir correção
      const idsUnicos = new Set();
      const resultadoLimpo = resultadoBruto.filter(rota => {
        if (idsUnicos.has(rota.id)) {
          return false;
        }
        idsUnicos.add(rota.id);
        return true;
      });

      // FIX: Validação manual adicional para garantir que só passem rotas corretas.
      // "every": cada chip da busca restringe o resultado (E entre chips) — adicionar
      // um segundo filtro (ex.: motorista + placa) precisa estreitar a lista
      const resultadoValidado = resultadoLimpo.filter(rota => {
        const filtroNome = filtros.find(f => f.getFiltroNome() === 'nome');
        if (filtroNome) {
          const comparadores = filtroNome.getComparadores();
          const passa = comparadores.every(comp =>
            rota.motorista.toUpperCase().includes(comp.toUpperCase()) ||
            rota.identificador?.toUpperCase().includes(comp.toUpperCase()) ||
            rota.placa?.toUpperCase().includes(comp.toUpperCase()) ||
            rota.nome?.toUpperCase().includes(comp.toUpperCase())
          );
          return passa;
        }
        return true;
      });

      resultado = resultadoValidado;
    } else {
      resultado = rotas;
    }

    return resultado;
  }
}
